import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@lifeomic/chroma-react/styles';

const styles = theme => ({
  gradientStart: {
    stopColor: theme.palette.primary.main,
    stopOpacity: 1,
  },
  gradientStop: {
    stopColor: theme.palette.secondary.main,
    stopOpacity: 1,
  },
});

/**
 * Not to be confused with the _other_ Marketplace icon in phc-web-toolkit,
 * this is the icon used for linking to the existing *mobile* marketplace
 * app management.  This will be replaced by Marketplace-proper in the near future.
 *
 * If you're looking for an icon to be used with the "new" Marketplace UI
 * (https://marketplace.dev.lifeomic.com), check out @lifeomic/phc-web-toolkit/src/components/Icons
 */
const MarketplaceIcon = ({ classes, ...props }) => {
  return (
    <svg
      viewBox="0 0 40 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.6242 7.23634C15.3724 4.98402 17.4965 3.35959 20 3.35959C22.5035 3.35959 24.6275 4.98402 25.3757 7.23634H14.6242ZM11.5211 7.23634C12.3445 3.30887 15.8278 0.359589 20 0.359589C24.1721 0.359589 27.6555 3.30887 28.4788 7.23634H30.6016H31.027L31.389 7.45961L39.2874 12.3306C39.8108 12.6534 40.0664 13.2458 39.9855 13.8181V44.5527C39.9855 45.7306 39.5176 46.8602 38.6847 47.6931C37.8518 48.526 36.7222 48.9939 35.5443 48.9939H4.45566C3.27777 48.9939 2.14813 48.526 1.31523 47.6931C0.482342 46.8602 0.0144281 45.7306 0.0144281 44.5527V13.8175C-0.0634778 13.2638 0.17272 12.6886 0.669418 12.3583L7.9947 7.48728L8.37207 7.23634H8.82527H11.5211ZM25.6632 10.2363H14.3367V13.4641H25.6632V10.2363ZM28.6632 13.4641V10.2363H30.1763L35.4101 13.4641H33.3237H28.6632ZM11.3367 13.4641H6.67627H4.42441L9.27847 10.2363H11.3367V13.4641Z"
        fill="url(#paint0_linear)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5 23C11.5 22.7239 11.7238 22.5 12 22.5H18.3C18.5761 22.5 18.8 22.7239 18.8 23V29.3C18.8 29.5761 18.5761 29.8 18.3 29.8H12C11.7238 29.8 11.5 29.5761 11.5 29.3V23ZM12.5 23.5V28.8H17.8V23.5H12.5ZM21.4 23C21.4 22.7239 21.6238 22.5 21.9 22.5H28.2C28.4761 22.5 28.7 22.7239 28.7 23V29.3C28.7 29.5761 28.4761 29.8 28.2 29.8H21.9C21.6238 29.8 21.4 29.5761 21.4 29.3V23ZM22.4 23.5V28.8H27.7V23.5H22.4ZM12 32.4C11.7238 32.4 11.5 32.6239 11.5 32.9V39.2C11.5 39.4761 11.7238 39.7 12 39.7H18.3C18.5761 39.7 18.8 39.4761 18.8 39.2V32.9C18.8 32.6239 18.5761 32.4 18.3 32.4H12ZM12.5 38.7V33.4H17.8V38.7H12.5Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="9.78716"
          y1="42.8221"
          x2="37.5815"
          y2="12.937"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" className={classes.gradientStart} />
          <stop offset="1" className={classes.gradientStop} />
        </linearGradient>
      </defs>
    </svg>
  );
};

MarketplaceIcon.propTypes = {
  classes: PropTypes.object,
};

export default withStyles(styles)(MarketplaceIcon);
